import { makeAsyncRoute } from '../utils/makeAsyncRoute';
const LinkedInSalesNavigatorRouteAsync = makeAsyncRoute(() => import( /* webpackChunkName: "sales-navigator-route" */'./LinkedInSalesNavigatorRoute').then(mod => mod.default), 'sales-navigator-route');
export default LinkedInSalesNavigatorRouteAsync;